import "angular";
import GroupService from "./GroupService";
import GroupFactory from "./GroupFactory";

const GroupModule = angular
    .module("GroupModule", [])
    .service("groupService", GroupService)
    .factory("groupFactory", GroupFactory);

export default GroupModule;
